<template>
  <div class="col-10 mx-auto">
    <h5>Crea nuovo abbonamento</h5>
    <div class="pt-2 col- mx-auto">
      <b-form @submit="onSubmit">
        <p class="text-left font-weight-bold">Slug:</p>
        <b-form-input class="my-2" id="slug" v-model="form.slug" type="text" required></b-form-input>

        <p class="text-left font-weight-bold">nome:</p>
        <b-form-input class="my-2" id="nome" v-model="form.nome" type="text" required></b-form-input>
        <p class="text-left font-weight-bold">descrizione:</p>
        <b-form-input class="my-2" id="descrizione" v-model="form.descrizione" type="text" required></b-form-input>
        <p class="text-left font-weight-bold">id prodotto woocommerce:</p>
        <b-form-input
          class="my-2"
          id="wc_product_id"
          v-model="form.wc_product_id"
          type="number"
          required
        ></b-form-input>
        <p class="text-left font-weight-bold">prezzo:</p>
        <b-form-input class="my-2" id="prezzo" v-model="form.prezzo" type="number" required></b-form-input>
        <p class="text-left font-weight-bold">durata (in mesi):</p>
        <b-form-input class="my-2" id="durata" v-model="form.durata" type="number" required></b-form-input>
        <b-form-radio v-model="form.attivo" name="attivo" :value="true">Attivo</b-form-radio>

        <div class="p-1 my-2">
          <p class="text-left font-weight-bold">servizi:</p>

          <b-form-checkbox-group id="servizi" v-model="form.servizi" name="servizi">
            <b-form-checkbox
              v-for="(servizio, ind) in servizi"
              :key="ind"
              :value="servizio.id"
            >{{ servizio.slug }}</b-form-checkbox>
          </b-form-checkbox-group>

          <!-- <b-button variant="primary" type="button" class="my-2">Aggiungi servizio</b-button> -->
          <div class="border rounded border-primary p-1">
            <p class="text-left font-weight-bold">crea nuovo servizio:</p>

            <p class="text-left font-weight-bold">Slug:</p>
            <b-form-input class="my-2" id="slug" v-model="nuovo.slug" type="text"></b-form-input>

            <p class="text-left font-weight-bold">nome:</p>
            <b-form-input class="my-2" id="nome" v-model="nuovo.nome" type="text"></b-form-input>
            <p class="text-left font-weight-bold">descrizione:</p>
            <b-form-input class="my-2" id="descrizione" v-model="nuovo.descrizione" type="text"></b-form-input>
            <b-button
              variant="primary"
              type="button"
              class="my-2"
              @click="storeServizio"
            >Crea nuovo servizio</b-button>
          </div>
        </div>

        <b-button block variant="primary" type="submit" class="my-2">Crea nuovo abbonamento</b-button>
      </b-form>
    </div>
    <div v-if="created">
      <p>Nuovo abbonamento creato</p>
      <div>{{ created }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NuovoAbbonamento",
  data() {
    return {
      form: {
        slug: null,
        nome: null,
        descrizione: null,
        servizi: [],
        attivo: false,
        durata: 1,
        wc_product_id: null
      },
      servizi: null,
      aggiunti: [],
      nuovo: {
        slug: null,
        nome: null,
        descrizione: null
      },
      created: null
    };
  },
  methods: {
    onSubmit(ev) {
      ev.preventDefault();
      console.log(this.form);
      var url = process.env.VUE_APP_VERSION + "admin/abbonamenti";
      this.$axios
        .post(url, this.form)
        .then(res => {
          console.log(res.data.data);
          this.created = res.data.data;
          this.getServizi();
          this.form = {
            slug: null,
            nome: null,
            descrizione: null,
            servizi: [],
            wc_product_id: null,
            durata: 1
          };
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getServizi() {
      var url = process.env.VUE_APP_VERSION + "admin/servizi";
      this.$axios
        .get(url)
        .then(res => {
          console.log(res.data.data);
          this.servizi = res.data.data;
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    storeServizio() {
      var url = process.env.VUE_APP_VERSION + "admin/servizi";
      this.$axios
        .post(url, this.nuovo)
        .then(res => {
          console.log(res.data.data);
          this.getServizi();
          this.nuovo = {
            slug: null,
            nome: null,
            descrizione: null
          };
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    this.getServizi();
  }
};
</script>
